// SETTINGS V2 — Pricing card 4 (Zahrnuté služby) — SETTINGS_V2_SP7 §5.
// Presentational: 6 SCheck rows in a 2-col grid (1-col on phone). Owns NO state —
// the checked map + toggle callback come from PricingPageV2. include* fields are
// mismatch-free (round-trip correctly), unlike the period-code selects.
import React from "react";

import useTranslation from "../../../../shared/hooks/useTranslation";
import { SCard, SCheck } from "../atoms";

export interface IncludedValues {
  includeDiagnostics: boolean;
  includeLaborForRepair: boolean;
  includePartsAndMaterials: boolean;
  includeTestingAndCalibration: boolean;
  includeWorkAreaCleanup: boolean;
  includeDetailedServiceReport: boolean;
}
export type IncludedKey = keyof IncludedValues;

const ROWS: { key: IncludedKey; labelKey: string }[] = [
  { key: "includeDiagnostics", labelKey: "settings:pricing.diagnostics" },
  { key: "includeLaborForRepair", labelKey: "settings:pricing.laborForRepair" },
  { key: "includePartsAndMaterials", labelKey: "settings:pricing.partsAndMaterials" },
  { key: "includeTestingAndCalibration", labelKey: "settings:pricing.testingAndCalibration" },
  { key: "includeWorkAreaCleanup", labelKey: "settings:pricing.workAreaCleanup" },
  { key: "includeDetailedServiceReport", labelKey: "settings:pricing.detailedServiceReport" },
];

export interface PricingIncludedCardV2Props {
  values: IncludedValues;
  onToggle: (key: IncludedKey) => void;
  isPhone: boolean;
  animationDelay: string;
}

const PricingIncludedCardV2: React.FC<PricingIncludedCardV2Props> = ({
  values,
  onToggle,
  isPhone,
  animationDelay,
}) => {
  const { translate: t } = useTranslation("settings");

  return (
    <SCard
      title={t("settings:pricing.includedServices")}
      hint={t("settings:pricing.includedServicesDescription")}
      style={{ animation: `sv2-card-reveal 0.4s ease-out ${animationDelay} both` }}
    >
      <div
        style={{
          display: "grid",
          gridTemplateColumns: isPhone ? "1fr" : "1fr 1fr",
          gap: "10px 24px",
        }}
      >
        {ROWS.map((row) => (
          <SCheck
            key={row.key}
            on={values[row.key]}
            onToggle={() => onToggle(row.key)}
            label={t(row.labelKey)}
          />
        ))}
      </div>
    </SCard>
  );
};

export default PricingIncludedCardV2;
